<template>
  <div class="success">
      <!-- {{login_state_msg}} -->
  </div>
</template>
 
<script>
import { useRoute} from "vue-router";
import {loginByWechat,bindWechat} from "@/api";
export default {
    setup() {
        const route = useRoute();
        const code = route.query.code;
        console.log(route.path)
        if(route.path == "/login_ewm"){//登录页面的二维码
            loginByWechat({code}).then(res=>{
                if(res && res.code && res.code == 200){
                    window.parent.loginSuccess(res);
                }else{
                    window.parent.loginFail(res);
                }
            }).catch(()=>{
                window.parent.loginFail();
            })
        }else if(route.path == "/bind_ewm"){//绑定微信页面的二维码
            bindWechat({code}).then(res=>{
                if(res && res.code && res.code == 200){
                    window.parent.bindSuccess(res);
                }else{
                    window.parent.bindFail(res)
                }
            }).catch(()=>{
                window.parent.loginFail();
            })
        }
    }
}
</script>

<style scoped>
.success{
    width: 100%;
    height: 100%;
    background: #fff;
}
</style>



